/**
 * 桥梁管理模块的事件总线
 * 用于组件间通信，减少父子组件直接耦合
 */
import Vue from 'vue';

// 创建原始的Vue事件总线
const originalBridgeEventBus = new Vue();

// 确保事件总线实例有效
if (!originalBridgeEventBus) {
  console.error('BridgeEventBus: 事件总线初始化失败');
}

// 创建增强版的安全事件总线
const BridgeEventBus = new Vue();

// 事件常量定义
export const BRIDGE_EVENTS = {
  // 地图相关
  MAP_READY: 'bridge_map_ready',
  MAP_CLICK: 'bridge_map_click',
  
  // 桥梁相关
  BRIDGE_SELECTED: 'bridge_selected',
  BRIDGE_CREATED: 'bridge_created',
  BRIDGE_UPDATED: 'bridge_updated',
  BRIDGE_DATA_LOADED: 'bridge_data_loaded',
  
  // 区域相关
  AREA_SELECTED: 'area_selected',
  AREA_CREATED: 'area_created',
  AREA_UPDATED: 'area_updated',
  AREA_DATA_LOADED: 'area_data_loaded',
  AREA_CLEARED: 'area_cleared', // 新增：区域被清除
  AREA_VISIBILITY_CHANGED: 'area_visibility_changed', // 新增：区域可见性变更
  AREA_COLOR_CHANGED: 'area_color_changed', // 新增：区域颜色变更
  
  // 绘制相关
  DRAWING_STARTED: 'drawing_started',
  DRAWING_ENDED: 'drawing_ended',
  DRAWING_CLEARED: 'drawing_cleared',
  
  // 位置拾取相关
  LOCATION_PICKING_STARTED: 'location_picking_started',
  LOCATION_PICKED: 'location_picked',
  
  // 警戒规则相关
  ALERT_RULE_UPDATED: 'alert_rule_updated',
  
  // 状态管理相关
  STATE_RESET: 'state_reset', // 新增：状态重置事件

  // 船舶相关
  SHIP_UPDATED: 'ship_updated',

};

// 用于存储最近发送的事件时间，用于节流
const _lastEventTimes = {};

// 添加节流发送事件的方法，防止短时间内重复发送相同事件
BridgeEventBus.throttleEmit = function(event, payload, throttleTime = 300) {
  const now = Date.now();
  if (!_lastEventTimes[event] || (now - _lastEventTimes[event] > throttleTime)) {
    // 发送事件 - 支持数组形式的多参数
    if (Array.isArray(payload)) {
      this.$emit(event, ...payload);
    } else {
      this.$emit(event, payload);
    }
    
    // 更新最后发送时间
    _lastEventTimes[event] = now;
    
    return true; // 表示事件已发送
  } else {
    console.log(`事件 ${event} 节流 - 跳过发送，间隔: ${now - _lastEventTimes[event]}ms`);
    return false; // 表示事件被节流，未发送
  }
};

export default BridgeEventBus;